import { createImageUpload } from "novel";
import { message } from "antd";

/** 论文台暂不接图床：粘贴/拖入图片直接拒绝，避免 Promise 挂死 */
const onUpload = (_file: File) => {
  message.warning("暂不支持插入图片");
  return Promise.reject(new Error("图片上传未配置"));
};

export const uploadFn = createImageUpload({
  onUpload,
  validateFn: (file) => {
    if (!file.type.includes("image/")) {
      message.warning("仅支持图片文件");
      return false;
    }
    if (file.size / 1024 / 1024 > 20) {
      message.warning("图片不能超过 20MB");
      return false;
    }
    // 校验通过后仍会走 onUpload → 明确拒绝
    return true;
  },
});
